angular.module("cpm").directive("fieldWrapper", function ($compile) {
  return {
      restrict: "E",
      scope: {
          fieldConfig: "=",
          fieldValue: "="
      },
      link: function (scope, element) {
          const { directive, attributes } = scope.fieldConfig;

          const directiveElem = angular.element(`<${directive}></${directive}>`);
          directiveElem.attr("ng-model", "fieldValue");

          if (attributes.options) {
              scope.options = attributes.options;
              directiveElem.attr("options", "options");
          }

          Object.keys(attributes).forEach(attr => {
              if (attr !== "options") {
                  directiveElem.attr(_.kebabCase(attr), attributes[attr]);
              }
          });

          $compile(directiveElem)(scope);
          element.append(directiveElem);
      }
  };
});
